var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIPadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82143 0C0.822679 0 0 0.813 0 1.8V10.2C0 11.187 0.822679 12 1.82143 12H15.1786C16.1773 12 17 11.187 17 10.2V1.8C17 0.813 16.1773 0 15.1786 0H1.82143ZM1.82143 1.2H15.1786C15.5155 1.2 15.7857 1.467 15.7857 1.8V10.2C15.7857 10.533 15.5155 10.8 15.1786 10.8H1.82143C1.48446 10.8 1.21429 10.533 1.21429 10.2V1.8C1.21429 1.467 1.48446 1.2 1.82143 1.2ZM2.42857 5.4C2.09464 5.4 1.82143 5.67 1.82143 6C1.82143 6.33 2.09464 6.6 2.42857 6.6C2.7625 6.6 3.03571 6.33 3.03571 6C3.03571 5.67 2.7625 5.4 2.42857 5.4Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPadIcon);
export default __webpack_public_path__ + "static/media/IPadIcon.f082d95e13cbf9dbb1b3319e3b957e70.svg";
export { ForwardRef as ReactComponent };